(function(){'use strict';function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}function generateBundleId(){return "bundle_".concat(Date.now(),"_").concat(Math.random().toString(36).slice(2,10))}var CustomBundle=function(t){_inherits(r,t);var e,i=_createSuper(r);function r(){var t;return _classCallCheck(this,r),(t=i.call(this)).data=null,t.productsById=new Map,t.selection=[],t.defaults=[],t.activeSlot=null,t.activeFilter="all",t.cart=document.querySelector("cart-notification")||document.querySelector("cart-drawer"),t}return _createClass(r,[{key:"connectedCallback",value:function(){var t=this,e=this.querySelector(".custom-bundle__data");if(e){try{this.data=JSON.parse(e.textContent);}catch(t){return void console.error("CustomBundle: failed to parse data",t)}this.abortController=new AbortController,this.data.products.forEach((function(e){return t.productsById.set(e.id,e)})),this.defaults=this.data.defaults.slice(0,this.data.slotCount),this.selection=this.defaults.slice(),this.discount=Number(this.data.discount)||0,this.badgeColor=this.getAttribute("data-badge-color"),this.badgeTextColor=this.getAttribute("data-badge-text-color"),this.slotsEl=this.querySelector("[data-cb-slots]"),this.reasonDefaultEl=this.querySelector("[data-cb-reason-default]"),this.reasonChangedEl=this.querySelector("[data-cb-reason-changed]"),this.selectorEl=this.querySelector("[data-cb-selector]"),this.listEl=this.querySelector("[data-cb-list]"),this.filtersEl=this.querySelector("[data-cb-filters]"),this.countEl=this.querySelector("[data-cb-count]"),this.panelSubEl=this.querySelector("[data-cb-panel-sub]"),this.panelTitleEl=this.querySelector("[data-cb-panel-title]"),this.slotTpl=this.querySelector("[data-cb-slot-template]"),this.optionTpl=this.querySelector("[data-cb-option-template]"),this.filterTpl=this.querySelector("[data-cb-filter-template]"),this.panelTitleEl.textContent=this.data.texts.popupHeadline,this.bindPriceRow(),this.renderSlots(),this.updatePrice(),this.updateReason(),this.bindSelector(),this.bindAddToCart(),this.updateAvailability(),this.observeSwitch();}}},{key:"disconnectedCallback",value:function(){this.abortController&&this.abortController.abort();}},{key:"isAbTestActive",value:function(){return !!this.closest('[data-custom-bundle="active"]')}},{key:"activateForAbTest",value:function(){document.documentElement.setAttribute("data-custom-bundle","active"),this.data&&this.updateAvailability();}},{key:"deactivateForAbTest",value:function(){document.documentElement.removeAttribute("data-custom-bundle"),this.data&&this.updateAvailability();}},{key:"observeSwitch",value:function(){var t=this,e=new MutationObserver((function(){return t.updateAvailability()}));e.observe(document.documentElement,{attributes:!0,attributeFilter:["data-custom-bundle"]}),this.abortController.signal.addEventListener("abort",(function(){return e.disconnect()}));}},{key:"bindPriceRow",value:function(){var t=this.getAttribute("data-section-id"),e=t&&document.querySelector("#price-".concat(t," [data-cb-price]"));this.oldPriceEl=e&&e.querySelector("[data-cb-old-price]"),this.newPriceEl=e&&e.querySelector("[data-cb-new-price]"),this.defaultOldPriceHtml=this.oldPriceEl?this.oldPriceEl.innerHTML:"";}},{key:"renderSlots",value:function(){var t=this;this.slotsEl.innerHTML="",this.slotEls=[],this.selection.forEach((function(e,i){var r=t.productsById.get(e);if(r){var s=t.slotTpl.content.cloneNode(!0),a=s.querySelector("[data-cb-slot]"),o=s.querySelector("[data-cb-slot-image]");o.src=r.image||"",o.alt=r.shortTitle||"",s.querySelector("[data-cb-slot-name]").textContent=r.shortTitle||"",s.querySelector("[data-cb-slot-desc]").textContent=r.description||"";var l=s.querySelector("[data-cb-slot-note]");l.textContent=r.bundleDescription||"",l.hidden=!r.bundleDescription,s.querySelector("[data-cb-swap]").addEventListener("click",(function(){return t.toggleSelector(i)})),t.slotsEl.appendChild(s),t.slotEls[i]=a;}}));}},{key:"money",value:function(t){var e="string"==typeof window.moneyFormat&&window.moneyFormat;if(!e)return "".concat(this.data.currency," ").concat((t/100).toFixed(2).replace(".",","));var i=function(e,i,r){var s=(t/100).toFixed(e).split("."),a=_slicedToArray(s,2),o=a[0],l=a[1],n=o.replace(/(\d)(?=(\d{3})+$)/g,"$1".concat(i));return l?n+r+l:n},r={amount:function(){return i(2,",",".")},amount_no_decimals:function(){return i(0,",")},amount_with_comma_separator:function(){return i(2,".",",")},amount_no_decimals_with_comma_separator:function(){return i(0,".")},amount_with_apostrophe_separator:function(){return i(2,"'",".")},amount_with_space_separator:function(){return i(2," ",",")},amount_no_decimals_with_space_separator:function(){return i(0," ")}};return e.replace(/<[^>]*>/g,"").replace(/\{\{\s*(\w+)\s*\}\}/,(function(t,e){return r[e]?r[e]():r.amount()}))}},{key:"setMoney",value:function(t,e){t&&(t.innerHTML=null===e?"":this.money(e));}},{key:"discounted",value:function(t){return Math.round(t*(1-this.discount/100))}},{key:"sumSelected",value:function(){var t=this;return this.selection.reduce((function(e,i){var r=t.productsById.get(i);return e+(r?r.price:0)}),0)}},{key:"updatePrice",value:function(){var t=this.sumSelected();this.discount>0?this.setMoney(this.oldPriceEl,t):this.oldPriceEl&&(this.oldPriceEl.innerHTML=this.isDefaultSelection()?this.defaultOldPriceHtml:""),this.setMoney(this.newPriceEl,this.discount>0?this.discounted(t):t);}},{key:"updateAvailability",value:function(){var t=this;if(this.isAbTestActive()){var e=this.selection.some((function(e){var i=t.productsById.get(e);return !i||!1===i.available}));this.classList.toggle("custom-bundle--soldout",e),(this.atcScopes||[]).forEach((function(i){i.querySelectorAll(".product-form__submit").forEach((function(i){var r=i;void 0===r.dataset.cbNativeDisabled&&(r.dataset.cbNativeDisabled=String(r.disabled),r.dataset.cbNativeAriaDisabled=r.getAttribute("aria-disabled")||""),r.disabled=e,r.setAttribute("aria-disabled",e?"true":"false");var s=r.querySelector(".product-form__submit-text");s&&(e?(s.dataset.cbLabel||(s.dataset.cbLabel=s.textContent.trim()),s.textContent=t.data.texts.soldOut||s.dataset.cbLabel):s.dataset.cbLabel&&(s.textContent=s.dataset.cbLabel));}));}));}else this.restoreNativeButtons();}},{key:"restoreNativeButtons",value:function(){(this.atcScopes||[]).forEach((function(t){t.querySelectorAll(".product-form__submit").forEach((function(t){var e=t;if(void 0!==e.dataset.cbNativeDisabled){e.disabled="true"===e.dataset.cbNativeDisabled;var i=e.dataset.cbNativeAriaDisabled;i?e.setAttribute("aria-disabled",i):e.removeAttribute("aria-disabled"),delete e.dataset.cbNativeDisabled,delete e.dataset.cbNativeAriaDisabled;var r=e.querySelector(".product-form__submit-text");r&&r.dataset.cbLabel&&(r.textContent=r.dataset.cbLabel,delete r.dataset.cbLabel);}}));}));}},{key:"isDefaultSelection",value:function(){var t=this;return this.selection.length===this.defaults.length&&this.selection.every((function(e,i){return e===t.defaults[i]}))}},{key:"updateReason",value:function(){var t=this.isDefaultSelection();this.reasonDefaultEl&&(this.reasonDefaultEl.hidden=!t),this.reasonChangedEl&&(this.reasonChangedEl.hidden=t);}},{key:"bindSelector",value:function(){var t=this;this.querySelector("[data-cb-close]").addEventListener("click",(function(){return t.closeSelector()})),this.querySelector("[data-cb-scrim]").addEventListener("click",(function(){return t.closeSelector()})),document.addEventListener("keydown",(function(e){"Escape"===e.key&&null!==t.activeSlot&&t.closeSelector();}),{signal:this.abortController.signal});}},{key:"toggleSelector",value:function(t){this.activeSlot===t?this.closeSelector():this.openSelector(t);}},{key:"setSlotOpenState",value:function(t,e){var i=this.slotEls[t];if(i){i.classList.toggle("is-open",e);var r=i.querySelector("[data-cb-swap]");r&&r.setAttribute("aria-expanded",e?"true":"false");}}},{key:"openSelector",value:function(t){null!==this.activeSlot&&this.setSlotOpenState(this.activeSlot,!1),this.activeSlot=t,this.activeFilter="all",this.setSlotOpenState(t,!0);var e=(this.data.texts.popupSubheadline||"").replace("{current}",t+1).replace("{total}",this.data.slotCount);if(this.panelSubEl.textContent=e,this.renderFilters(),this.renderOptions(),window.matchMedia("(max-width: 749px)").matches)this.selectorEl.style.top="",this.selectorEl.style.left="",this.selectorEl.style.width="","function"==typeof this.selectorEl.showPopover?(this.selectorEl.setAttribute("popover","manual"),this.selectorEl.hidden=!1,this.popoverOpen||this.selectorEl.showPopover(),this.popoverOpen=!0):document.body.appendChild(this.selectorEl),this.scrollPosition=window.pageYOffset||document.documentElement.scrollTop,document.body.classList.add("overflow-hidden-mobile"),this.scrollLocked=!0;else {var i=this.slotEls[t];i&&(this.selectorEl.style.top="".concat(i.offsetTop+i.offsetHeight+4,"px"),this.selectorEl.style.left="".concat(i.offsetLeft,"px"),this.selectorEl.style.width="".concat(i.offsetWidth,"px"));}this.selectorEl.hidden=!1,this.selectorEl.setAttribute("aria-hidden","false"),this.selectorEl.classList.add("is-open");}},{key:"closeSelector",value:function(){null!==this.activeSlot&&this.setSlotOpenState(this.activeSlot,!1),this.activeSlot=null,this.selectorEl.hidden=!0,this.selectorEl.setAttribute("aria-hidden","true"),this.selectorEl.classList.remove("is-open"),this.selectorEl.style.top="",this.selectorEl.style.left="",this.selectorEl.style.width="",this.popoverOpen?(this.selectorEl.hidePopover(),this.selectorEl.removeAttribute("popover"),this.popoverOpen=!1):this.selectorEl.parentElement!==this&&this.appendChild(this.selectorEl),this.scrollLocked&&(document.body.classList.remove("overflow-hidden-mobile"),this.scrollPosition>0&&window.scrollTo(0,this.scrollPosition),this.scrollLocked=!1);}},{key:"renderFilters",value:function(){var t=this;this.filtersEl.innerHTML="";var e=function(e,i){var r=t.filterTpl.content.cloneNode(!0),s=r.querySelector("[data-cb-filter]");s.textContent=i,s.dataset.filterKey=e,e===t.activeFilter&&s.classList.add("is-active"),s.addEventListener("click",(function(){return t.onFilterClick(e)})),t.filtersEl.appendChild(r);};e("all",this.data.texts.allLabel),(this.data.filters||[]).forEach((function(t,i){return e(String(i),t.label)}));}},{key:"onFilterClick",value:function(t){this.activeFilter="all"===t||this.activeFilter===t?"all":t,this.renderFilters(),this.renderOptions();}},{key:"matchesFilter",value:function(t){if("all"===this.activeFilter)return !0;var e=this.data.filters[Number(this.activeFilter)];return !e||e.productIds.includes(t)}},{key:"renderOptions",value:function(){var t=this;this.listEl.innerHTML="";var e=new Set(this.selection.filter((function(e,i){return i!==t.activeSlot}))),i=0;this.data.products.forEach((function(r){if(t.matchesFilter(r.id)&&!1!==r.available){i+=1;var s=t.optionTpl.content.cloneNode(!0),a=s.querySelector("[data-cb-option]"),o=s.querySelector("[data-cb-option-image]");o.src=r.image||"",o.alt=r.shortTitle||"",s.querySelector("[data-cb-option-name]").textContent=r.shortTitle||"",s.querySelector("[data-cb-option-desc]").textContent=r.description||"";var l=s.querySelector("[data-cb-option-old]"),n=s.querySelector("[data-cb-option-new]");t.setMoney(l,t.discount>0?r.price:null),t.setMoney(n,t.discount>0?t.discounted(r.price):r.price);var c=t.selection[t.activeSlot]===r.id,d=e.has(r.id);if(c&&a.classList.add("is-current"),d){a.classList.add("is-disabled"),a.disabled=!0;var u=s.querySelector("[data-cb-option-badge]");u.textContent=t.data.texts.badgeText,u.hidden=!1,t.badgeColor&&(u.style.backgroundColor=t.badgeColor),t.badgeTextColor&&(u.style.color=t.badgeTextColor);}else a.addEventListener("click",(function(){return t.selectOption(r.id)}));t.listEl.appendChild(s);}})),this.countEl.textContent="".concat(i," ").concat(this.data.texts.countLabel);}},{key:"selectOption",value:function(t){null!==this.activeSlot&&(this.selection[this.activeSlot]=t,this.closeSelector(),this.renderSlots(),this.updatePrice(),this.updateReason(),this.updateAvailability());}},{key:"bindAddToCart",value:function(){var t=this,e=this.getAttribute("data-section-id"),i=[],r=e&&document.getElementById("ProductInfo-".concat(e));r&&i.push(r),document.querySelectorAll(".sticky-atc").forEach((function(t){return i.push(t)})),this.atcScopes=i;var s=function(e){if(t.isAbTestActive()){var i=e.target;if(i&&i.closest){var r=i.closest('[name="add"], [type="submit"], .product-form__submit');if(r){var s=r.closest('form[action*="/cart/add"]');if(s){var a=s.getAttribute("id")||"";if(-1===a.indexOf("installment"))if(!r.closest("quick-add-modal, atc-popup-modal"))(!!r.closest(".sticky-atc")||0===a.indexOf("product-form-"))&&(e.preventDefault(),e.stopImmediatePropagation(),t.classList.contains("custom-bundle--soldout")||t.addBundleToCart(s));}}}}};i.forEach((function(e){return e.addEventListener("click",s,{capture:!0,signal:t.abortController.signal})}));}},{key:"showAddError",value:function(t,e){var i=t.closest("product-form"),r=this.getAttribute("data-section-id"),s=i&&i.querySelector(".product-form__error-message-wrapper")||document.querySelector("#ProductInfo-".concat(r," .product-form__error-message-wrapper"));if(s){s.toggleAttribute("hidden",!e);var a=s.querySelector(".product-form__error-message");a&&(a.textContent=e||"");}}},{key:"addBundleToCart",value:(e=_asyncToGenerator(_regeneratorRuntime().mark((function t(e){var i,r,s,a,o,l,n,c,d,u,h=this;return _regeneratorRuntime().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return i=generateBundleId(),r=this.selection.map((function(t){return {id:h.productsById.get(t).variantId,quantity:1,properties:{_bundle_id:i,_bundle_parent:h.data.parentGid,_bundle_discount:String(h.data.discount||0),_bundle:"true"}}})),this.showAddError(e,!1),(s=e.querySelector('[type="submit"]'))&&(s.setAttribute("aria-disabled","true"),s.classList.add("loading"),(a=s.querySelector(".loading__spinner"))&&a.classList.remove("hidden")),t.prev=5,o={items:r},this.cart&&(o.sections=this.cart.getSectionsToRender().map((function(t){return t.id})),o.sections_url=window.location.pathname),(l="function"==typeof fetchConfig?fetchConfig("javascript"):{method:"POST",headers:{"Content-Type":"application/json"}}).headers["X-Requested-With"]="XMLHttpRequest",l.body=JSON.stringify(o),n=window.routes&&window.routes.cart_add_url||"/cart/add",t.next=14,fetch("".concat(n,".js"),l);case 14:return c=t.sent,t.next=17,c.json();case 17:if(!(d=t.sent).status){t.next=20;break}throw new Error(d.description||d.message);case 20:"function"==typeof publish&&"undefined"!=typeof PUB_SUB_EVENTS&&publish(PUB_SUB_EVENTS.cartUpdate,{source:"custom-bundle",cartData:d}),this.cart?(void 0===d.key&&Array.isArray(d.items)&&d.items.length&&(d.key=d.items[0].key),this.cart.setActiveElement&&this.cart.setActiveElement(document.activeElement),this.cart.renderContents(d),this.cart.classList.remove("is-empty")):window.location=window.routes.cart_url,t.next=29;break;case 24:t.prev=24,t.t0=t.catch(5),console.error("CustomBundle: add to cart failed",t.t0),this.showAddError(e,t.t0&&t.t0.message),"function"==typeof publish&&"undefined"!=typeof PUB_SUB_EVENTS&&publish(PUB_SUB_EVENTS.cartError,{source:"custom-bundle",message:t.t0&&t.t0.message});case 29:return t.prev=29,s&&(s.classList.remove("loading"),s.removeAttribute("aria-disabled"),(u=s.querySelector(".loading__spinner"))&&u.classList.add("hidden")),t.finish(29);case 32:case"end":return t.stop()}}),t,this,[[5,24,29,32]])}))),function(t){return e.apply(this,arguments)})}]),r}(_wrapNativeSuper(HTMLElement));customElements.define("custom-bundle",CustomBundle);})();